import type { TourFrame, TourStep, onAddStepProps } from '@carboncopyco/types';
import {
  TourStepAddDirection,
  type TourStepConfigUpdate,
  tooltipDefaultConfig,
} from '@carboncopyco/types';
import type { RefObject } from 'react';

export const frameHasStepWithJumpToStepTargetButton = (
  frame: TourFrame,
  sourceStep: TourStep
) => {
  const goToStepIdNextButton =
    sourceStep?.config?.tooltip.buttons.nextButton?.action?.goToStepId;
  const goToStepIdPrevButton =
    sourceStep?.config?.tooltip.buttons.previousButton?.action?.goToStepId;
  return frame.steps.some(
    (targetStep) =>
      targetStep.stepId === goToStepIdNextButton ||
      targetStep.stepId === goToStepIdPrevButton
  );
};

export const getUpdatedSteps = ({
  activeFrame,
  step,
  frames,
  referenceStepId,
  direction,
}: onAddStepProps & {
  activeFrame: RefObject<TourFrame>;
  frames: TourFrame[];
}) => {
  let steps;
  if (activeFrame?.current?.steps) {
    if (referenceStepId && direction) {
      const referenceStepIndex = activeFrame.current?.steps.findIndex(
        (step) => step.stepId === referenceStepId
      );
      steps = [
        ...activeFrame.current.steps.slice(
          0,
          direction === TourStepAddDirection.below
            ? referenceStepIndex + 1
            : referenceStepIndex
        ),
        step,
        ...activeFrame.current.steps.slice(
          direction === TourStepAddDirection.below
            ? referenceStepIndex + 1
            : referenceStepIndex
        ),
      ];
    } else {
      steps = [...activeFrame.current.steps, step];
    }
  }
  return steps;
};

export const generateStepCounterUpdates = (
  frames: TourFrame[]
): TourStepConfigUpdate[] => {
  const hasStepsWithoutCounterOptions = frames.some((frame) =>
    frame.steps.some((step) => !step.config?.tooltip.text.stepCount)
  );

  if (!hasStepsWithoutCounterOptions) {
    return [];
  }

  return [
    {
      path: 'config.tooltip.text.step_count',
      value: tooltipDefaultConfig.text.stepCount,
    },
  ];
};

export const generateShowTooltipConfigUpdate = (
  showToltips: boolean
): TourStepConfigUpdate[] => {
  return [
    {
      path: 'show_tooltip',
      value: showToltips,
    },
    {
      path: 'config.tooltip.highlight_element_options.is_active',
      value: !showToltips,
    },
    {
      path: 'config.tooltip.navigation_options.is_element_navigation',
      value: !showToltips,
    },
  ];
};
